import React, { Component, Fragment } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import Rotas from '@/app/routes';
import AppContext from './context/AppContext';
import Header from '@/components/template/header';
import Body from '@/components/template/body';
import Paper from '@/components/template/paper';
import { ApplicationContextConsumer } from './context/AppContext';
import Footer from '@/components/template/footer';
import ObraContextProvider from '@/views/obras/context/ObraContext'

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css'

import 'bootstrap/dist/css/bootstrap.min.css'
import ErrorBoundary from '@/components/template/error';

class App extends Component {
  headerComps = ()=>{
    let tema = this.props.context.tema;
    return (
       <React.Fragment>
            {tema.showHeader && (
              <Header title={process.env.REACT_APP_CORP_TITLE} 
                      shortTitle={process.env.REACT_APP_TITLE} 
                      descricao={process.env.REACT_APP_SUBTITLE} 
              />
            ) }

            {tema.showPaper && (
              <Paper />
            )}
            
       </React.Fragment>
    );
  }

  footer = ()=>{
    let tema = this.props.context.tema;
    return (
       <React.Fragment>
            {tema.showFooter && <Footer/>}
       </React.Fragment>
    );
  }

  render() {
    const tema = this.props.context.tema;
    const Footer = () => this.footer()
    return (
        <Router>
            <Fragment>
              <div className={tema.container}>
                <div className="row h-100">
                  {this.headerComps()}
                  <Body>              
                      <ErrorBoundary>
                      <Rotas />
                      </ErrorBoundary>  
                      <Footer />
                  </Body>
                </div>
              </div>
            </Fragment>
        </Router>
    );
  }
}

export default props => (
  <AppContext>
    <ObraContextProvider>
      <ApplicationContextConsumer>
          {(appContext) => (
              <App context={appContext} />
          )}
      </ApplicationContextConsumer>
    </ObraContextProvider>
  </AppContext>
)
